import * as React from 'react';
import Highcharts from 'highcharts';
import HighchartsReact  from 'highcharts-react-official';
import HighchartMore from 'highcharts/highcharts-more';
import ChartTheme from '../chartTheme';

(window as any).Highcharts = Highcharts;
HighchartMore(Highcharts);
require('highcharts/modules/heatmap')(Highcharts);
require('highcharts/modules/exporting')(Highcharts);
require('highcharts/modules/offline-exporting')(Highcharts);
Highcharts.setOptions(ChartTheme as any);

const Chart = ({ options, refs, callback }) => ( 
  <HighchartsReact
    highcharts={Highcharts}
    constructorType={'chart'}
    options={options}
    ref={refs}
    callback={callback}
  />
);
export default Chart;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSChart/components/Chart.tsx